<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="seismiccontractorForm">
      <div class="">
        <h3 class="form_name">Contractor Form</h3>
  
        <div class="input">
          <label for="">Contractor Name<span class="text-danger">*</span></label>
          <input type="text" class="default_input reference-form" formControlName="ContractorName" />
        </div>
        <div class="input">
            <label for="">Phone Number<span class="text-danger">*</span></label>
            <input type="text" class="default_input reference-form" formControlName="PhoneNo" />
          </div>
          <div class="input">
            <label for="">Email<span class="text-danger">*</span></label>
            <input type="email" class="default_input reference-form" formControlName="Email" />
          </div>
          <div class="input">
            <label for="">Address<span class="text-danger">*</span></label>
            <input type="text" class="default_input reference-form" formControlName="Address" />
          </div>
          <div class="input">
            <label for="">Website</label>
            <input type="email" class="default_input reference-form" formControlName="Website" />
          </div>
      
        
  
        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null" 
            (click)="addNew(seismiccontractorForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null" 
            (click)="addNew(seismiccontractorForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Contractor name"
          #name
          />
          <em  class="ti-search" (click)="searchContractors(name.value)"></em>
  
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
         
          <span class="item">Contractor</span>
          <span class="item">Phone</span>
          <span class="item">Email</span>
          <span class="item">Address</span>
          <span class="item">Website</span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let seismiccontractor of seismiccontractorFormArray.get('SeismicContractors')['controls']; index as i"
        (click)="onEdit(i, seismiccontractor.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          
          <span class="content">{{seismiccontractor.value.ContractorName}}</span>
          <span class="content">{{seismiccontractor.value.PhoneNo}}</span>
           <span class="content">{{seismiccontractor.value.Email}}</span>
           <span class="content">{{seismiccontractor.value.Address}}</span>
           <span class="content">{{seismiccontractor.value.Website}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteSeismicContractor(i, seismiccontractor.value)">
            <em  class="ti-trash"> </em></button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(seismiccontractorFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>